/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Feature_Free_1_UserInputs */



/**
* | output |
* | --- |
* | "1 user account" |
*
* @param {Plan_Feature_Free_1_UserInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_feature_free_1_user = /** @type {((inputs?: Plan_Feature_Free_1_UserInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Feature_Free_1_UserInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("1 Benutzerkonto")
	return /** @type {LocalizedString} */ ("1 user account")
});